import {
  GET_FAV_REQUEST_SUCCESS, GET_FAV_REQUEST_FAILED,
  ADD_FAV_REQUEST_SUCCESS, ADD_FAV_REQUEST_FAILED,
  REMOVE_FAV_REQUEST_SUCCESS, REMOVE_FAV_REQUEST_FAILED,
  CLEAR_FAV
} from "../actions/fav_actions";

const initialState = {
  favorites: [],
  count: 0,
}

export const favReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_FAV_REQUEST_SUCCESS: {
      return {
        ...state,
        favorites: [...action.payload],
        count: action.payload.length
      }
    }
    case GET_FAV_REQUEST_FAILED: {
      return {
        ...state,
        favorites: [],
        count: 0
      }
    }
    case ADD_FAV_REQUEST_SUCCESS: {
      return {
        ...state,
        favorites: [...action.payload],
        count: action.payload.length
      }
    }
    case ADD_FAV_REQUEST_FAILED: {
      return {
        ...state,
        favorites: [],
        count: 0
      }
    }
    case REMOVE_FAV_REQUEST_SUCCESS: {
      return {
        ...state,
        favorites: [...action.payload],
        count: action.payload.length
      }
    }
    case REMOVE_FAV_REQUEST_FAILED: {
      return {
        ...state,
        favorites: [],
        count: 0
      }
    }
    case CLEAR_FAV: {
      return {
        ...state,
        favorites: [],
        count: 0
      }
    }
    default: return state;
  }
}
